import React, { Component } from 'react'
import MappingBreedList from '../../../components/MappingBreedList'
import { SearchOptions } from '../../../components/TableHelper'
import { MappingBreedConsumer } from '../../../context/MappingBreedContext'

type MappingBreedProps = {
  filters: any | null,
  history: any,
  permissions: any,

  onLoad?: (searchOptions: SearchOptions) => void
}

export default class MappingBreed extends Component<MappingBreedProps> {

  handleOnLoad = (searchOptions: SearchOptions) => {
    if (this.props.onLoad) {
      this.props.onLoad(searchOptions)
    }
  }

  render() {
    const { permissions, filters, history } = this.props

    return (
      <MappingBreedConsumer>
        {({ fetching, mappingBreeds, pagination, requestMappingBreedList }) => {

          return <MappingBreedList permissions={permissions} loading={fetching} mappingBreeds={mappingBreeds} pagination={pagination} filters={filters} history={history} onLoad={this.handleOnLoad} loadMappingBreeds={requestMappingBreedList} />
        }}
      </MappingBreedConsumer>
    )
  }
}
